"use client";

import * as React from "react";
import useEmblaCarouselOriginal from "embla-carousel-react";

export type { UseEmblaCarouselType } from "embla-carousel-react";

type Options = Parameters<typeof useEmblaCarouselOriginal>[0];
type Plugins = Parameters<typeof useEmblaCarouselOriginal>[1];

/**
 * embla-carousel 默认按 LTR 计算滑块偏移。RTL 页面（ar/he/fa）下 flex 行
 * 方向反转，必须显式传 direction: 'rtl'，否则滑块被平移到视口外（轮播空白、
 * 切换失效）。此封装按 <html dir> 自动注入 direction，组件内显式传入的
 * options.direction 优先。
 */
export default function useEmblaCarousel(options?: Options, plugins?: Plugins) {
  const [isRtl, setIsRtl] = React.useState(false);
  React.useEffect(() => {
    setIsRtl(document.documentElement.dir === "rtl");
  }, []);

  return useEmblaCarouselOriginal(
    { direction: isRtl ? "rtl" : "ltr", ...options },
    plugins,
  );
}
